import React, { useEffect } from "react";
import { Flex, Text } from "@radix-ui/themes";
import { Button } from "../../../ui/Button";
import _ from "lodash";
import { TbEdit, TbPlus } from "react-icons/tb";
import { useTranslation } from "react-i18next";
import { NavLink, Outlet, useLocation, useNavigate, useParams } from "react-router-dom";
import RoleRequire from "../../../helpers/auth/RoleRequire";
import { useAppStore } from "../../../stores/RootStore";
import { ColumnDef } from "@tanstack/react-table";
import { DataTable } from "../../../ui/DataTable/DataTable";
import { Separator } from "../../../ui/Separator";
import { Input } from "../../../ui/Input/Input";
import { EquipmentTypeTableData } from "../../../types/formDataTypes";
import { useEquipmentTypes } from "../../../hooks/useFetchStateHooks/useEquipmentTypes";
import { MenuDataTable } from "../../../ui/DataTable/MenuDataTable";
import { Header } from "../../../components/Header";

type Props = {};

export const EquipmentTypes = (props: Props) => {
  let {id} = useParams();
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  const [search, setSearch] = React.useState("");
  const currentSite = useAppStore().currentSite
  const types = useAppStore((state) => state.equipmentTypes);

  // Получение данных и обновление их в сторе.
  const updateItems = useEquipmentTypes();
  useEffect(() => {
    updateItems();
  }, []);

  let nodes = types?.map((producer) => {
    return {
      id: producer.id,
      name: producer.attributes.name,
    };
  });

  // Сортировка по умолчанию
  nodes = _.sortBy(nodes, []);
  let data = { nodes };

  const handleSearch = (event: any) => {
    setSearch(event.target.value);
  };

  // Фильтрация через поиск
  data = {
    nodes: data.nodes?.filter((item) => item.name.toLowerCase().includes(search.toLowerCase())),
  };

  const columns: ColumnDef<EquipmentTypeTableData>[] = [
    {
      accessorKey: "name",
      header: t("title_name"),
      size: 1000,
      cell: ({ row }) => row.getValue("name"),
    }
  ];

  return (
    <div className="flex flex-col w-full h-full">
      <div className="flex-none flex w-full h-14 px-6 justify-between items-center">
        <div className="flex text-base items-center gap-1">
          <NavLink to={"/"}>
            <span className="font-medium">{currentSite?.name ? currentSite?.name : "..."}</span> 
          </NavLink>
          <span>/</span>
          <NavLink to={"/data/directories"}>
            <span className="font-medium">{t("directories")}</span>
          </NavLink> 
          <span>/</span>
          {location.pathname == "/data/equipment_types/" || location.pathname == "/data/equipment_types" ? <span>{t("equipment_types")}</span> : <NavLink to={"/data/equipment_types"}><span>{t("equipment_types")}</span></NavLink>}
          {(id || location.pathname == "/data/equipment_types/new") && <span>/</span>}
          {id && <span>{data.nodes.find(n => n.id == id)?.name}</span>}
          {location.pathname == "/data/equipment_types/new" && <span>{t('adding_equipment_type')}</span>}
        </div>
      </div>
      <Separator className="flex-none"/>
      {id || location.pathname == "/data/equipment_types/new" ? <Outlet /> :
        <div className="flex flex-col w-full h-full mx-auto overflow-hidden">
          <Header name={t('equipment_types')} backName={t("directories")} backLink={"/data/directories"} />
          <div className="flex-none flex flex-row w-full h-10 items-center gap-4 justify-between px-6">
            <Input 
              className="h-8"
              placeholder={t("search")}
              onChange={handleSearch}
              value={search}
              autoComplete="off"
              width="100%" 
            />
            <RoleRequire role="maintainer">
              <Button variant={"default"} size={"md"} onClick={() => navigate("new")}>{t("create_equipment_type")}</Button>
            </RoleRequire>
          </div>
          <MenuDataTable route="/data/equipment_types" data={data.nodes} columns={columns} onClickRow={navigate} />
        </div>
      }
    </div>
  )
};
